// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"FoolScreen_foolScreen__1vQpu","secondScreenBlock":"FoolScreen_secondScreenBlock__2bnuX","controllers":"FoolScreen_controllers__1VyuM"};